<template>
<div id="purchase-edit">
  <h2>Create Purchase</h2>

  <purchase-nav></purchase-nav>

  <purchase-form></purchase-form>
</div>
</template>

<script>
import PurchaseForm from '@/components/PurchaseForm'
import PurchaseNav from '@/components/PurchaseNav'

export default {
  components: {
    'purchase-form': PurchaseForm,
    'purchase-nav': PurchaseNav
  },

  created () {
    this.$forceUpdate()
    this.$on('processErrors', this.$parent.processErrors)
  },

  watch: {
    '$route' (to, from) {
      this.get()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PurchaseCreate.vue